var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 975.52,
    height: 804.35,
    viewBox: "0 0 1300 1004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#f6f9ff;}.c{fill:#daf9fe;}.d{fill:#2BA9DE;}.e{fill:#d4e9fa;stroke:#a5ccec;}.f{fill:#f1f4f9;stroke:#cad0d9;}.g{fill:#ffda37;}.h{fill:#458072;}.i{fill:#243650;}.j,.k{fill:#5eb4a0;}.j{opacity:0.8;}.l{fill:#79c0b0;}.m{fill:#069ad9;}.n,.s{fill:none;}.n{stroke:#fff;stroke-width:3px;}.o{clip-path:url(#a);}.p{clip-path:url(#b);}.q{fill:#304669;font-size:120px;font-family:MicrosoftYaHei-Bold, Microsoft YaHei;font-weight:700;letter-spacing:0.02em;}.r{stroke:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 528,
    height: 502
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 428,
    height: 232,
    transform: "translate(1492 848)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1920,
    height: 1080
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M273.711,70.271c22.59-33.569,71.988-33.569,94.578,0L582.226,388.176C607.706,426.039,580.574,477,534.937,477H107.063c-45.638,0-72.769-50.961-47.289-88.824Z",
    transform: "translate(273.141 728.391) rotate(-50)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M163.7,77.081c22.336-35.645,74.265-35.645,96.6,0L369.317,251.055c23.788,37.962-3.5,87.266-48.3,87.266H102.984c-44.8,0-72.089-49.3-48.3-87.266Z",
    transform: "translate(863.093 445.019) rotate(-65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-14490.143-6386.106c-3.048,7.111-76.194,113.783-86.354,136.134s-28.447,98.544,44.7,129.022,237.728-30.477,278.364-42.668,341.351-41.653,357.605-46.733,98.545-94.481,101.593-175.755-37.591-179.819-96.514-217.408-341.351,23.367-388.083,48.765S-14487.095-6393.218-14490.143-6386.106Z",
    transform: "translate(15631 6974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-15635-6048.807h831.271l-17.169,17.169H-15635Z",
    transform: "translate(15631 6974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-13407.147-7778.9v287.586h149.264s51.241-56.869,60.956-66.426,42.145-22.606,64.082-3.908,22.662,35.167,67.207,28.133,64.083-44.545,85.964-58.611,63.3-50.015,113.314,9.378,54.109,43.738,58.8,37.486c0-12.023,5.284-233.639,5.284-233.639Z",
    transform: "translate(13548 8331)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(173 574)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 130,
    height: 231
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    x: 0.5,
    y: 0.5,
    width: 129,
    height: 230
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(315 574)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 128,
    height: 45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 44
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 44,
    height: 45,
    transform: "translate(181 582)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 36,
    height: 34,
    transform: "translate(322 579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 69,
    height: 6,
    transform: "translate(229 582)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 77,
    height: 6,
    transform: "translate(362 582)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 69,
    height: 6,
    transform: "translate(229 601)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 57,
    height: 6,
    transform: "translate(362 601)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 61,
    height: 6,
    transform: "translate(229 591)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 65,
    height: 6,
    transform: "translate(362 591)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 6,
    transform: "translate(229 610)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(467 574)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 236,
    height: 79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    x: 0.5,
    y: 0.5,
    width: 235,
    height: 78
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(315 641)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 128,
    height: 103
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 102
  })), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 6,
    height: 33,
    rx: 3,
    transform: "matrix(0.755, -0.656, 0.656, 0.755, 92, 750.016)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 6,
    height: 33,
    rx: 3,
    transform: "translate(75.5 813.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 6,
    height: 33,
    rx: 3,
    transform: "translate(140.853 717.832) rotate(-17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 6,
    height: 33,
    rx: 3,
    transform: "matrix(0.839, 0.545, -0.545, 0.839, 213.926, 724.262)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 6,
    height: 33,
    rx: 3,
    transform: "matrix(0.052, 0.999, -0.999, 0.052, 254.32, 786.168)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 6,
    height: 33,
    rx: 3,
    transform: "translate(238.421 861.34) rotate(131)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.835 -9.745)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M387.652,733.444S419.57,778.959,416.1,859.1l6.428-5.936s4.2-55.738-34.386-120.546Z",
    transform: "translate(33.723 23.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M436.756,733.464s-31.921,45.515-28.453,125.66l-6.424-5.939s-4.207-55.738,34.382-120.546Z",
    transform: "translate(68.068 23.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M396.005,740.022s14.467,18.179,11.5,108.715h5.936s-5.565-99.686-16.818-109.581Z",
    transform: "translate(54.081 39.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M467.688,838.44h-73.1L386.751,762.5h88.77Z",
    transform: "translate(31.527 96.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M475.085,778.9c-1.344.148-3.681-.722-3.8-2.117s1.987-2.819,3.382-2.932a36.859,36.859,0,0,1,7.046.244c.113-1.976.56-3.99.918-6.812.619-4.888-.619-5.689-2.289-11.319l-.041-.148a23.178,23.178,0,0,0-11.549,2.863c-.378.2-1.11.9-1.509.9-.911,0-2.207-1.227-2.664-2.086-.656-1.234-.464-3.623.773-4.279a47.075,47.075,0,0,1,13.412-2.464,25.594,25.594,0,0,0-2.935-6.163,35.04,35.04,0,0,0-4.413-5.706,59.118,59.118,0,0,0-11.869,4.262c-.368.186-.766.832-1.151.832a3.713,3.713,0,0,1-2.8-1.654c-.629-1.251.419-3.076,1.67-3.708a65.046,65.046,0,0,1,10.263-4.008c-4.344-4.784-7.538-5.091-12.226-7.892-.151-.089-.285-.155-.433-.241a39.542,39.542,0,0,0-5,5.723,2.531,2.531,0,0,1-2.1,1.117c-.485,0-2.124.344-2.557.055-1.162-.784-.327-2.839.454-4a41.173,41.173,0,0,1,4.234-5.111,46.2,46.2,0,0,0-6.338-1.189c-4.455-.68-7.359,1.3-9.277,2.537s-2.1,2.967-3.217,5.008a13.319,13.319,0,0,0-1.3,4.7,31.85,31.85,0,0,1-9.71-3.956c-2.846-1.918-7.854-4.207-13.481-2.351s-5.07,9.648-4.455,14.471a20.448,20.448,0,0,0,.842,3.825,24.187,24.187,0,0,1,12.278-9.125c1.839-.323,3.784,1.612,4.09,3.451a3.382,3.382,0,0,1-2.75,3.887c-.371.073-6.046,1.3-9.583,8.153l.01.014c2.719,2.842,1.609,2.781,4.575,7.851,2.21,3.777,4.8,4.743,7.61,6.249a35.837,35.837,0,0,1,12.188-10.116c1.7-.784,3.014.928,4.489,1.65,1.674.818.045,3.7-1.643,4.482a29.569,29.569,0,0,0-9.748,8.253c1.7,2.365,2.41,5.049,6.582,9.088,4.685,4.527,4.365,3.2,6.262,3.726a23.957,23.957,0,0,1,7.943-9.635c1.392-1.237,3.6-2.523,3.833-.2.186,1.849,1.636,3.458.251,4.7a23.751,23.751,0,0,0-6.72,10.105,11.971,11.971,0,0,0,4.448,4.9c3.028,1.664,5.1,1.114,7.744,1.43,1.877-4.3,2.98-7.332,3.293-7.627,1.344-1.289,4.242-1.729,5.537-.378,1.279,1.34,1.6,4.726.275,6.019a16.152,16.152,0,0,0-2.715,4.234c3.747,1.461,6.318,1.512,8.438,2.753,2.537,1.485,8.844,2.351,9.648,1.3s1.791-3.65,3.338-7.359.8-6.74,1.547-9.4c.7-2.5-.674-3.014-1.763-6.383A35.42,35.42,0,0,0,475.085,778.9Z",
    transform: "translate(68.067 0.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M475.085,778.9c-1.344.148-3.681-.722-3.8-2.117s1.987-2.819,3.382-2.932a36.859,36.859,0,0,1,7.046.244c.113-1.976.56-3.99.918-6.812.619-4.888-.619-5.689-2.289-11.319l-.041-.148a23.178,23.178,0,0,0-11.549,2.863c-.378.2-1.11.9-1.509.9-.911,0-2.207-1.227-2.664-2.086-.656-1.234-.464-3.623.773-4.279a47.075,47.075,0,0,1,13.412-2.464,25.594,25.594,0,0,0-2.935-6.163,35.04,35.04,0,0,0-4.413-5.706,59.118,59.118,0,0,0-11.869,4.262c-.368.186-.766.832-1.151.832a3.713,3.713,0,0,1-2.8-1.654c-.629-1.251.419-3.076,1.67-3.708a65.046,65.046,0,0,1,10.263-4.008c-4.344-4.784-7.538-5.091-12.226-7.892-.151-.089-.285-.155-.433-.241a39.542,39.542,0,0,0-5,5.723,2.531,2.531,0,0,1-2.1,1.117c-.485,0-2.124.344-2.557.055-1.162-.784-.327-2.839.454-4a41.173,41.173,0,0,1,4.234-5.111,46.2,46.2,0,0,0-6.338-1.189c-4.455-.68-7.359,1.3-9.277,2.537s-2.1,2.967-3.217,5.008a13.319,13.319,0,0,0-1.3,4.7,31.85,31.85,0,0,1-9.71-3.956c-2.846-1.918-7.854-4.207-13.481-2.351s-5.07,9.648-4.455,14.471a20.448,20.448,0,0,0,.842,3.825,24.187,24.187,0,0,1,12.278-9.125c1.839-.323,3.784,1.612,4.09,3.451a3.382,3.382,0,0,1-2.75,3.887c-.371.073-6.046,1.3-9.583,8.153l.01.014c2.719,2.842,1.609,2.781,4.575,7.851,2.21,3.777,4.8,4.743,7.61,6.249a35.837,35.837,0,0,1,12.188-10.116c1.7-.784,3.014.928,4.489,1.65,1.674.818.045,3.7-1.643,4.482a29.569,29.569,0,0,0-9.748,8.253c1.7,2.365,2.41,5.049,6.582,9.088,4.685,4.527,4.365,3.2,6.262,3.726a23.957,23.957,0,0,1,7.943-9.635c1.392-1.237,3.6-2.523,3.833-.2.186,1.849,1.636,3.458.251,4.7a23.751,23.751,0,0,0-6.72,10.105,11.971,11.971,0,0,0,4.448,4.9c3.028,1.664,5.1,1.114,7.744,1.43,1.877-4.3,2.98-7.332,3.293-7.627,1.344-1.289,4.242-1.729,5.537-.378,1.279,1.34,1.6,4.726.275,6.019a16.152,16.152,0,0,0-2.715,4.234c3.747,1.461,6.318,1.512,8.438,2.753,2.537,1.485,8.844,2.351,9.648,1.3s1.791-3.65,3.338-7.359.8-6.74,1.547-9.4c.7-2.5-.674-3.014-1.763-6.383A35.42,35.42,0,0,0,475.085,778.9Z",
    transform: "translate(68.067 0.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M439.758,745.816c-1.866.285-5.493.065-5.785-1.777s2.9-4.616,4.743-4.9c.6-.1,9.669-1.447,17.619.76.227-4.441-.4-9.473-4.778-10.917-5.627-1.856-10.635.433-13.481,2.351a31.827,31.827,0,0,1-9.707,3.956,13.26,13.26,0,0,0-1.3-4.7c-1.114-2.042-1.3-3.774-3.217-5.011s-4.822-3.214-9.277-2.533-6.988.8-11.748,3.647c-1.557.931-2.942,1.581-4.266,2.213a51.608,51.608,0,0,1,9.511,4.685c1.176.76,2.224,2.918.753,3.5-.828.33-1.3,1.158-2.131,1.158a2.522,2.522,0,0,1-1.375-.406,48.313,48.313,0,0,0-12.508-5.4,23.74,23.74,0,0,0-2.413,2.351c-4.111,4.623-5.489,5.8-7.576,8.964a30.554,30.554,0,0,1,11.7,3.891c1.179.756,2.152,3.035,1.4,4.211-.485.756-1.932.457-2.767.457a2.553,2.553,0,0,1-1.365-.4,25.97,25.97,0,0,0-11.628-3.324,74.669,74.669,0,0,0-2.372,7.349c-1.45,4.891-2.574,6.146-2.437,9.593,9.679.114,14.3,3.788,14.533,3.987,1.079.9,1.825,2.726.928,3.8-.5.6-1.818.684-2.543.684a2.5,2.5,0,0,1-1.6-.567c-.113-.086-3.485-2.578-10.672-2.822.461,2.9.76,5.036-.065,8.019-.811,2.932-1.88,3.926-2.114,5.283,4.585-1.31,7.129-.371,7.538-.2a2.536,2.536,0,0,1-1.915,4.7c-.144-.034-1.822-.468-5.07.639a16.97,16.97,0,0,0,1.127,6.032c1.547,3.709,2.537,6.307,3.338,7.359s7.112.186,9.648-1.3c1.976-1.158,4.341-1.279,7.686-2.468a22.95,22.95,0,0,0-4.63-5.5c-1.079-.89-.34-3.568.553-4.647s1.6-.145,2.674.739a28.285,28.285,0,0,1,6.115,7.421c3.991-1.375,6.287.158,10.174-1.977,2.791-1.533,3.884-4.083,5.262-6.235a52.986,52.986,0,0,0-4.867-7.3c-.887-1.083-1.048-3.85.034-4.733s3,.443,3.887,1.523a60.136,60.136,0,0,1,4.816,7.077c2.626-1.055,1.746,1.027,6.885-3.939a27.639,27.639,0,0,0,5.424-7.239c-4.221-7.177-9.171-10.263-9.469-10.366-1.317-.454-2.722-.863-2.275-2.183a2.537,2.537,0,0,1,3.193-1.595c.357.12,6.8,2.368,11.927,9.992.038-.031.065-.062.1-.093,3.96-3.049,7.607-3.049,10.576-8.122s1.856-5.008,4.575-7.854a15.788,15.788,0,0,0,4.252-7C450.114,744.922,442.9,745.331,439.758,745.816Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M429.256,757.878a2.558,2.558,0,0,1,2.887-2.117,39.578,39.578,0,0,1,10.851,3.533c.155-1.169.333-2.4.464-4.111a18.827,18.827,0,0,0-.932-6.854,10.537,10.537,0,0,0-8.871-.007c-1.255.643-3.609.894-4.252-.344s.677-3.513,1.922-4.156a16.481,16.481,0,0,1,9.335-1.413l-.058-.189c-1.4-4.815-2.99-8.012-5.163-7.717s-5.4-1.584-8.593,2.87-5.132,7.513-6.091,7.613-4.705-7.167-4.705-7.167-4.362-6.493-6.672-6.981c-1.739-.365-5.493-.041-8.84,3.454a23.881,23.881,0,0,1,10.624,7.232c.859,1.107,1.227,3.358.12,4.221-.461.357-1.578-.13-2.121-.13a2.527,2.527,0,0,1-2-.973,19.072,19.072,0,0,0-9.659-5.874c-.021.045-.045.072-.065.117-3.279,6.823-2.959,7.49-4.891,13.061a31.354,31.354,0,0,1,11.566,2.145c1.286.543,3.145,1.794,1.344,3.317-1.069.9-2.031,1.88-3.317,1.351a26.448,26.448,0,0,0-11.446-1.6,36.913,36.913,0,0,0-2.049,15.808,23.313,23.313,0,0,1,14.185-.158c1.32.474,3.1,2.292,2.629,3.613s-3,1.633-4.327,1.165a18.2,18.2,0,0,0-11.662.491c.155.725.285,1.437.481,2.2a57.54,57.54,0,0,0,4.558,12.577,25.387,25.387,0,0,1,8.046-3.729c1.361-.333,4.269-.192,3.035,1.9-.708,1.2-.529,2.719-1.894,3.035a21.209,21.209,0,0,0-6.479,3.121,35.516,35.516,0,0,0,4.417,4.994c5.792,5.438,10.167,7.864,11.281,7.8a29.046,29.046,0,0,0,14.388-8.249,20.472,20.472,0,0,0-5.613-3.918c-1.286-.55-1.193-1.935-1.334-3.327-.247-2.454,2.049-1.88,3.327-1.334a25.678,25.678,0,0,1,6.823,4.633c4.021-5.018,7.7-8.83,9.569-13.924a29.887,29.887,0,0,0-9.916-5.379c-1.347-.378-2.712-1.853-2.337-3.2s2.337-2.059,3.7-1.681a34.86,34.86,0,0,1,10.013,4.953A36.478,36.478,0,0,0,442.8,766.2c-.031-.43-.045-.8-.062-1.179-3.822-2.561-9.078-4.523-11.367-4.252C429.576,760.981,429.043,759.259,429.256,757.878Z",
    transform: "translate(35.758 19.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M458.615,794.935l-.141-.323c-.058-.144-6.286-14.381-20.561-30.591-14.526-16.491-27.848-36.7-27.982-36.895l-.192-.3.684-.454.2.292c1.437,2.159,14.189,21.214,27.913,36.8,14.364,16.309,20.451,30.23,20.706,30.814l.141.323Z",
    transform: "translate(87.551 8.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M375.784,793.941l-.595-.375c.1-.158,9.93-15.718,13.587-23.648,3.8-8.246,12.913-16.983,22.709-25.958,10.068-9.226,13.171-17.406,13.2-17.489l.663.244c-.031.083-3.183,8.418-13.388,17.763-9.741,8.926-18.795,17.609-22.545,25.738C385.741,778.188,375.883,793.786,375.784,793.941Z",
    transform: "translate(3.349 8.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M395.677,799.921c-.01-.155-.8-15.677.419-27.687.684-6.692,1.148-8.008,1.794-9.83a49.266,49.266,0,0,0,2.169-8.748c2.227-12.119,3.468-18.8,3.468-18.8l.691.134s-1.237,6.675-3.465,18.791a49.635,49.635,0,0,1-2.2,8.858c-.626,1.777-1.083,3.063-1.756,9.669-1.22,11.955-.423,27.422-.416,27.577Z",
    transform: "translate(52.642 29.123)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 36,
    height: 34,
    transform: "translate(322 648)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 77,
    height: 6,
    transform: "translate(362 651)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 59,
    height: 6,
    transform: "translate(362 670)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 68,
    height: 6,
    transform: "translate(362 660)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 64,
    height: 62,
    transform: "translate(476 582)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 150,
    height: 6,
    transform: "translate(546 585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 103,
    height: 6,
    transform: "translate(546 604)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 122,
    height: 6,
    transform: "translate(546 594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-11804.648-3535.184a200.908,200.908,0,0,0,12.147-23.08c1.67-5.77-3.492-15.032-5.771-27.483s1.366-25.509,4.707-32.494,19.59-28.023,44.642-27.483,37.5,15.792,43.579,24.447,5.618,37.049-3.037,48.741-26.572,25.206-38.72,27.939c-10.629,9.87-21.714,30.065-23.991,29.913S-11804.648-3535.184-11804.648-3535.184Z",
    transform: "translate(11915 4400)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M-11804.648-3535.111c1.6,1.21,33.05,20.186,33.458,20.677s-7.034,5.194-8.752,5.6a17.232,17.232,0,0,1-12.351-2.985c-4.948-3.517-12.433-8.056-14.027-9.733s-1.145-7.975.164-10.469A29.8,29.8,0,0,0-11804.648-3535.111Z",
    transform: "translate(11915 4400)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M-11781.176-3552.709c2.44-3.356,7.376-15,9.547-21.911s4.343-15,2.961-20.332-5.024-8.469-8.618-6.312-5.66,3.774-2.7,8.985,5.384,6.828,8.353,8,6.741,2.965,13.66,1.977,10.243-5.391,11.231-8.086-.18-7.547-1.977-8.985-7.368-.9-8.177,3.594-.45,10.512,2.875,15,8.356,6.3,11.681,6.158,10.511-.948,12.758-3.014,2.518-5.211,1.708-5.75-5.751.27-8.716,3.235-6.289,5.121-9.7,9.164-9.794,12.668-11.681,15.634-5.84,9.075-6.109,11.231",
    transform: "translate(11915 4400)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 5,
    height: 57.307,
    rx: 2.5,
    transform: "translate(113.886 841.644) rotate(-62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 5,
    height: 57.307,
    rx: 2.5,
    transform: "translate(110.352 847.644) rotate(-62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 5,
    height: 57.307,
    rx: 2.5,
    transform: "translate(107.352 853.644) rotate(-62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 5,
    height: 57.307,
    rx: 2.5,
    transform: "translate(103.76 860.727) rotate(-60)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "o"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 354,
    cy: 354,
    r: 354,
    transform: "translate(-180 -228)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 277.5,
    cy: 238,
    rx: 277.5,
    ry: 238,
    transform: "translate(1610 934)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "q",
    transform: "translate(238 432)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "WELCOME")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogin);
export default __webpack_public_path__ + "static/media/UserLogin.2dc3857d9334c738cd98d250581f4513.svg";
export { ForwardRef as ReactComponent };